import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { post, get } from '../axios/axios';

// 把flexible.js这个文件在main.js在全局引入
import flexible from './flexible';
Vue.use(flexible);

Vue.config.productionTip = false;

//放入原型
Vue.prototype.$post = post;
Vue.prototype.$get = get;

// Vue.use(Swiper);

// const originalPush = router.prototype.push
// router.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }

new Vue({
	router,
	store,
	render: function(h) {
		return h(App);
	},
}).$mount('#app');
